import React from 'react';
import ReactDOM from 'react-dom/client';
import { initReactI18next, useTranslation } from 'react-i18next';
import { createBrowserRouter, Outlet, RouterProvider, useRouteError } from 'react-router-dom';
import resourcesToBackend from "i18next-resources-to-backend";
import { FingerprintJSPro, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react'
import i18n from 'i18next';

import 'frontier-css/css/frontier.css';

import SiteContainer from './SiteContainer';
import QueueWait from './screens/QueueWait';
import QueueJoin from './screens/QueueJoin';
import QueueFinish from './screens/QueueFinish';
import { FINGERPRINT_KEY } from './API';

i18n.use(initReactI18next).use(resourcesToBackend(async (l: string)=>{
	var lang = (await import(`./locale/public.${l}.json`)).default;
	return lang;
})).init({
	fallbackLng: 'es',
	interpolation: {
		escapeValue: false,
	}
});

var Root = ()=>{
	var ErrorElement = () => {
		var { t } = useTranslation();
		const error = (useRouteError() as any);
		return <div>
			<div className="fr centered header" style={{ fontSize: 100 }}>
				{error.status}
				<div className="sub header" style={{ fontSize: 20 }}>
					{error.status === 404 ? t('notfound.message') : t('common.unexpected_error', { code: `LC-${error.status}` })}
				</div>
			</div>
		</div>
	}
	
	const Router = createBrowserRouter([{
		path: '/',
		errorElement: <SiteContainer outlet={<ErrorElement />} />,
		element: <SiteContainer outlet={<Outlet />} />,
		children: [
			{ path: '/', element: <QueueJoin /> },
			{ path: '/w/:token', element: <QueueWait /> },
			{ path: '/f/:token', element: <QueueFinish /> },
			{ path: '/rj/:token', element: <QueueJoin rejoin /> },
			{ path: '/:token', element: <QueueJoin /> }
		]
	}]);

	return <RouterProvider router={Router} />
}


const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);

root.render(
	<React.StrictMode>
		<FpjsProvider
			loadOptions={{
				apiKey: FINGERPRINT_KEY,
				endpoint: [
					"https://antifraud.payfront.mx",
					FingerprintJSPro.defaultEndpoint
				],
				scriptUrlPattern: [
					"https://antifraud.payfront.mx/web/v<version>/<apiKey>/loader_v<loaderVersion>.js",
					FingerprintJSPro.defaultScriptUrlPattern
				]
			}}
		>
			<Root />
		</FpjsProvider>
	</React.StrictMode>
);